
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import angular from 'angular';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';

const componentOptions = {
    bindings: {
        quanty: '=',
        available: '=',
        dataequalrow: '=',
        modules: '=',
        view: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibBaggagesBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-baggages-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-baggages-box-module',
    selector: 'ibBaggagesBox',
    inject: ['$scope', 'localStorageService', '$rootScope', 'DatalayerUtilsService', 'CommonsConstants', 'DatalayerConstants', 'CommonsUtilService', 'AncillariesUtilsService'],
    required: ['']
};

export class ibBaggagesBox implements ng.IController {

    public quanty = 0;

    constructor (
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsUtilService: CommonsUtilService,
        private AncillariesUtilsService: AncillariesUtilsService) {
    }

    $onInit () {
        if (!this.quanty) {
            this.quanty = 0;
        }
    }
    /**
      * Emit event to parent for open modal of baggages
      */
    openBaggages = (): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries('elegir equipaje', 'click', 'anadir');
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.AncillariesUtilsService.isMMBFlow() && this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_CUSTOMIZE_YOU_FLIGHT');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
        this.$scope.$emit('openBaggages');
    };
}

try {
    const mod = angular.module(componentInfo.module);
    let moduleOrNname: string;
    ibBaggagesBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBaggagesBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBaggagesBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBaggagesBox})
    );
}